import React from "react";
import styled from "styled-components";

import { doctoresEquipo } from "../components/Messages";
import { device, Colors } from "../components/Variables";
import { TextContainer } from "../components/Styles";

const MainSectionTitle = styled.h1`
    font-weight: 600;
    padding: 0 0 1rem 0;
    text-transform: capitalize !important;
    border-bottom: 2px solid ${Colors.ColorE};
    color: #434343fc;
    margin: 0 0 1rem 0;
    font-size: 3rem;
`;

const EquipoWrapper = styled.div`
    display: flex;
    flex-direction: column;
    gap: 40px;
    margin-top: 40px;
`;

const EquipoCard = styled.div`
    display: flex;
    flex-direction: column;
    background-color: ${Colors.ColorB};
    border-radius: 8px;
    overflow: hidden;
    padding: 24px;
    gap: 24px;
    align-items: center;

    @media ${device.tablet || "@media (min-width: 768px)"} {
        flex-direction: row;
        justify-content: space-between;
        align-items: stretch;
        gap: 48px;
        padding: 40px;

        &:nth-child(even) {
            flex-direction: row-reverse;
        }
    }
`;

const EquipoImg = styled.div`
    flex: 0 0 100%;
    max-width: 240px;
    display: flex;
    align-items: flex-start;
    justify-content: center;

    @media ${device.tablet || "@media (min-width: 768px)"} {
        flex: 0 0 25%;
    }

    img {
        width: 100%;
        height: auto;
        object-fit: cover;
        display: block;
        border-radius: 4px;
    }
`;

const EquipoInfo = styled.div`
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    width: 100%;

    .first-line {
        display: flex;
        align-items: center;
    }

    h2 {
        margin: 0 0 0 0;
        padding: 0;
        font-size: 1.5rem;
        color: ${Colors.ColorA};
        line-height: 1.2;
    }

    span {
        margin: 0 5px;
        font-weight: 100;
    }

    h3 {
        margin: 0 0 0px 0;
        font-size: 1.05rem;
        font-weight: 400;
        color: ${Colors.ColorB};
        line-height: 1.3;
    }

    .matriculas-container {
        display: flex;
        align-items: center;
        margin: 10px 0 10px;
        color: ${Colors.ColorA};
        font-size: 0.85rem;
    }

    .matricula {
        margin: 0;
        padding: 0;
        font-weight: 900;
    }

    .bio-container {
        display: flex;
        flex-direction: column;
        gap: 12px;
    }

    .sub-container {
        display: flex;
        flex-direction: column;
        gap: 12px;
        margin: 5px 0 10px;

        .sub-title {
            text-transform: unset;
            color: ${Colors.ColorI};
            font-size: 1.1rem;
            font-weight: 600;
            margin: 20px 0 0;
            text-decoration: underline;

        }
    }

    .bio-text {
        margin: 0;
        padding: 0;
        line-height: 1.6;
        color: #343a40;
    }
`;

const MapBiography = () => {
    return (
        <TextContainer>
            <MainSectionTitle>Nuestro Equipo</MainSectionTitle>
            <EquipoWrapper>
                {doctoresEquipo.map((equipo, index) => (
                    <EquipoCard key={index}>
                        <EquipoImg>
                            <img src={equipo.Imagen} alt={equipo.Nombre} />
                        </EquipoImg>
                        <EquipoInfo>
                            <div className="first-line">
                                <h2>{equipo.Nombre}</h2>
                                <span> • </span>
                                <span>{equipo.Especialidad}</span>
                            </div>

                            {(equipo.MN || equipo.MP) && (
                                <div className="matriculas-container">
                                    {equipo.MN && <span className="matricula">{equipo.MN}</span>}
                                    {equipo.MN && equipo.MP && <span>•</span>}
                                    {equipo.MP && <span className="matricula">{equipo.MP}</span>}
                                </div>
                            )}

                            <div className="bio-container">
                                {equipo.Bio.map((bio, idx) => (
                                    <p className="bio-text" key={idx}>
                                        {bio.paragraph}
                                    </p>
                                ))}
                            </div>

                            <div className="sub-container">
                                <h2 className="sub-title">Atención y tratamientos</h2>
                            </div>

                            {equipo.SubSpecialidades.length > 0 && (
                                <ul className="sub-container">
                                    {equipo.SubSpecialidades.map((esp, idx) => (
                                        <li className="sub-text" key={idx}>
                                            {esp.sub}
                                        </li>
                                    ))}
                                </ul>
                            )}
                        </EquipoInfo>
                    </EquipoCard>
                ))}
            </EquipoWrapper>
        </TextContainer>
    );
};

export default MapBiography;
